var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container -flex flex-justify-center loader-pad",attrs:{"role":"status","aria-live":_vm.accessible ? 'polite' : 'off',"aria-label":"Loading..."}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"icon -loading",attrs:{"aria-hidden":"true"}})])
}]

export { render, staticRenderFns }